<template>
    <b-dropdown :text="currentAssignee.name" class="assign" variant="light">
        <b-dropdown-item-button key="no-user" @click="setAssignee({})">
            {{ $t("settings.smart-routing.assignables.users.none") }}
        </b-dropdown-item-button>
        <b-dropdown-item-button
            v-for="user in usersTeamsTree.usersTree"
            :key="user.id"
            :active="currentRoute.userId === user.id"
            @click="setAssignee({ userId: user.id })"
        >
            {{ user.name }}
        </b-dropdown-item-button>

        <b-dropdown-divider v-if="usersTeamsTree.teamsTree.length > 0"></b-dropdown-divider>

        <b-dropdown-group v-for="team in usersTeamsTree.teamsTree" :key="`team-${team.id}`">
            <b-dropdown-item-button
                :active="!currentRoute.userId && currentRoute.teamId === team.id"
                @click="setAssignee({ teamId: team.id })"
            >
                <font-awesome-icon :color="team.color" class="mr-1" icon="users" />
                {{ team.name }}
            </b-dropdown-item-button>
            <b-dropdown-item-button
                v-for="teamUser in team.users"
                :key="`teamuser-${teamUser.id}`"
                :active="currentRoute.userId === teamUser.id && currentRoute.teamId === team.id"
                class="ml-3"
                @click="setAssignee({ userId: teamUser.id, teamId: team.id })"
            >
                {{ teamUser.name }}
            </b-dropdown-item-button>
        </b-dropdown-group>
    </b-dropdown>
</template>

<script>
import { computed, watch } from "@vue/composition-api";
import { BDropdown, BDropdownItemButton, BDropdownDivider, BDropdownGroup } from "bootstrap-vue";
import { resolveTeamsUsersTree } from "@/utils/users";
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";
import useUsers from "@/composables/useUsers";
import useRoutes from "@/views/modules/settings/smart-routing/useRoutes";
import useChannels from "@/composables/v2.1/useChannels";

export default {
    components: {
        BDropdown,
        BDropdownItemButton,
        BDropdownDivider,
        BDropdownGroup,
    },
    setup() {
        const { users, teams } = useUsers();
        const { currentRoute } = useRoutes();
        const toast = useToast();
        const { channels } = useChannels();

        const currentChannel = computed(() =>
            channels.value?.find((channel) => channel.id === currentRoute.value.channelId)
        );

        const usersTeamsTree = computed(() => {
            try {
                return resolveTeamsUsersTree(teams.value, users.value, null, currentChannel.value);
            } catch {
                toast.warning(i18n.t("settings.smart-routing.loading-users.error"));
            }
        });

        const currentAssignee = computed(() => {
            const none = {
                name: i18n.t("settings.smart-routing.assignables.users.none-selected"),
            };

            if (currentRoute.value.userId) {
                return users.value.find((user) => user.id === currentRoute.value.userId) || none;
            }
            if (currentRoute.value.teamId) {
                return teams.value.find((team) => team.id === currentRoute.value.teamId) || none;
            }

            return none;
        });

        watch(
            () => currentRoute.value.channelId,
            () => {
                if (!usersTeamsTree.value.teamsTree.find((teamTree) => teamTree.id === currentRoute.value.teamId)) {
                    currentRoute.value.teamId = null;
                }

                if (
                    !usersTeamsTree.value.usersTree.find((userTree) => userTree.id === currentRoute.value.userId) &&
                    !usersTeamsTree.value.teamsTree.find((teamTree) =>
                        teamTree.users.find((user) => user.id === currentRoute.value.userId)
                    )
                ) {
                    currentRoute.value.userId = null;
                }
            }
        );

        const setAssignee = ({ userId, teamId }) => {
            currentRoute.value.userId = userId || null; // Specifically null so it overwrites currently saved value
            currentRoute.value.teamId = teamId || null; // Specifically null so it overwrites currently saved value
        };

        return {
            users,
            teams,
            currentRoute,
            usersTeamsTree,
            currentAssignee,
            setAssignee,
        };
    },
};
</script>

<style>
.dropdown-menu .dropdown-item {
    width: 100%;
}
.assign .dropdown-menu {
    overflow-y: auto;
    max-height: 40rem;
}
.user-status-badge {
    height: 14px;
    width: 14px;
}
.user-status-badge:empty {
    display: inline-block;
}
</style>
